import React, { useState, useEffect } from 'react'
import Button from 'srcReact/components/common2/Button'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { messengerActions } from 'srcReact/MessengerPage'
import Spinner from 'srcReact/components/common2/Spinner'

export default function SayHi({ isNative }) {
  const { t } = useTranslation()
  const [hasInvalidUser, setHasInvalidUser] = useState(false)

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    messenger: { openedConversation, loadingSendMessage }
  } = useSelector((state) => state)

  useEffect(() => {
    if (openedConversation && openedConversation.active_users.length === 2) {
      const isInvalid = openedConversation.active_users.some(
        (x) => x.status === 'deleted' || x.status === 'deactivated'
      )
      setHasInvalidUser(isInvalid)
    }
  }, [openedConversation])

  const sayHi = () => {
    dispatch(
      messengerActions.postMessage(openedConversation.conversation.id, `<div>${t('messenger.chatWindow.hi')}</div>`)
    )
  }

  return (
    <div className={`${styles.container} ${isNative && styles.isNativeView}`}>
      {!hasInvalidUser && (
        <React.Fragment>
          <span className={styles.emoji}>&#128075;</span>
          <Button
            size='large'
            handleClick={sayHi}
            text={
              loadingSendMessage ? (
                <Spinner isWhite={true} customCss={styles.spinner} />
              ) : (
                t('messenger.chatWindow.sayhi')
              )
            }
          />
        </React.Fragment>
      )}
    </div>
  )
}
